<template>
  <div>
    <div class="image">
      <p class="font">搜索</p>
      <p>search</p>
    </div>
    <div class="search-box">
      <input
        class="input"
        v-model="search"
        placeholder="请输入关键词"
        @keyup.enter="handleEnterKey"
      />
      <img @click="request()" class="img" src="../assets/home/search.png" alt="">
    </div>

    <div class="section">
      <div class="box" v-for="(item, i) in arr" :key="i">
        <p class="title" @click="routerlink(item)">{{ item }}</p>
        <p class="content">{{ item.content }}</p>
      </div>
      <div v-show="show" style="text-align: center">
        找不到结果，请输入正确的关键词
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      arr: [],
      show: false,
    };
  },
  mounted() {
    this.search = ''
  },
  methods: {
    handleEnterKey(event) {
      console.log(event);
      if (event.key === "Enter") {
        this.request();
      }
    },
    request() {
      let param = {
        keyword: this.search,
        pageSize: 10,
        pageNo: 1,
      };
      this.$get("/search", param)
        .then((res) => {
          console.log(res);
          if (res.data.success == true) {
            console.log("成功");
            this.arr = res.data.data;
            if (res.data.data.length == 0) {
              this.show = true;
            } else {
              this.show = false;
            }
          } else {
            this.$message({
              message: "请求失败",
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "请求失败",
            type: "error",
          });
        });
    },
    routerlink(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style>
.el-input__inner {
  height: 60px !important;
  line-height: 60px !important;
}
</style>
<style lang="scss" scoped>
.image {
  width: 100%;
  background-image: url("../assets/product/search.png");
  height: 300px;
  text-align: center;
  color: #fff;
  font-weight: 600;
  font-size: 30px;
  padding-top: 100px;
  box-sizing: border-box;
}
.search-box{
  position: relative;
  width: 50%;
  margin: -30px 25% 20px;
  .img{
    width: 40px;
    position: absolute;
    top: 10px;
    right: 30px;
  }
}
.input {
 width: 100%;

  height: 60px;
  border: 1px solid #ccc;
  font-size: 20px;
}
.input:focus {
  border-color: #288cba !important;
}
.section {
  min-height: 300px;
  margin: 10px 5%;
  .box {
    margin: 20px auto;
    .title {
      font-weight: 600;
      font-size: 25px;
      color: #288cba;
      cursor: pointer;
    }
    .content {
      margin: 10px auto;
      cursor: pointer;
    }
  }
}
</style>

